// VmNode.jsx (API-frei)
import { useEffect, useState } from 'react';
import { Position, Handle, useReactFlow } from 'reactflow';
import { Box, Card, Checkbox, Typography } from '@mui/material';
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined';
import { green, red } from '@mui/material/colors';

export default function VmNode({ id, data }) {
  const rf = useReactFlow();
  const [vm, setVm] = useState(data || {});

  useEffect(() => {
    setVm(data || {});
  }, [data]);

  const shadowColor = vm.state === 'running' ? green[300] : red[500];
  const borderColor = vm.state === 'running' ? green[600] : red[600];

  const patchNodeData = (patch) => {
    setVm((prev) => ({ ...prev, ...patch }));
    rf.setNodes((nds) =>
      nds.map((n) =>
        n.id === id ? { ...n, data: { ...n.data, ...patch } } : n,
      ),
    );
  };

  return (
    <Card
      sx={{
        p: 1,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: `0 0 20px 1px ${shadowColor}`,
        height: '100%',
        width: '100%',
        position: 'relative',
        minWidth: 230,
        minHeight: 120,
        border: `2px solid ${borderColor}`,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box>
          <Typography
            variant="h5"
            fontWeight="bold"
            noWrap
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {vm.title}
          </Typography>
          <Typography variant="body2" fontWeight="bold">
            {vm.shutdownThreshold ?? 0}%
          </Typography>
        </Box>
        <ViewInArOutlinedIcon
          sx={{
            color: 'white',
            bgcolor: 'grey.300',
            borderRadius: '20%',
            p: 1,
            fontSize: 48,
            flexShrink: 0,
          }}
          titleAccess="Virtual Machine Node"
        />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 0 }}>
        <Checkbox
          checked={!!vm.excludeFromStart}
          size="small"
          sx={{ p: 0.5 }}
          onChange={(e) =>
            patchNodeData({ excludeFromStart: e.target.checked })
          }
        />
        <Typography variant="caption" sx={{ lineHeight: 1 }}>
          Von Start ausschließen
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 0 }}>
        <Checkbox
          checked={!!vm.excludeFromStop}
          size="small"
          sx={{ p: 0.5 }}
          onChange={(e) => patchNodeData({ excludeFromStop: e.target.checked })}
        />
        <Typography variant="caption" sx={{ lineHeight: 1 }}>
          Von Stopp ausschließen
        </Typography>
      </Box>

      <Handle
        type="target"
        position={Position.Top}
        id="vm-target"
        style={{ bottom: -2 }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="vm-source"
        style={{ bottom: -2 }}
      />
    </Card>
  );
}
